var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"contact-item"},[_c('div',{staticClass:"contact-details"},[_c('div',{staticClass:"contact-info"},[_c('div',{staticClass:"contact-name"},[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")])])]),_c('div',{staticClass:"number-details"},[_vm._v("\n    "+_vm._s(_vm.numberFormatter(_vm.number))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }